import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private http: HttpClient) { }

  public upload(formData, url) {
    return this.http.post(url, formData, { responseType: 'text' });
  }
}
